import { api } from "./client"

export type Job = {
  id: string
  organization_id: string
  title: string
  slug: string
  status: "draft" | "open" | "closed"
  department: string | null
  location: string | null
  employment_type: "full_time" | "part_time" | "contract" | "internship"
  description: string | null
  requirements: string | null
  salary_min: number | null
  salary_max: number | null
  currency: "TRY" | "USD" | "EUR" | "GBP"
  published_at: string | null
  created_at: string
}

export type JobInput = Omit<
  Job,
  "id" | "organization_id" | "status" | "published_at" | "created_at"
>

export const jobsApi = {
  list: (params?: { status?: string }) =>
    api<{ data: Job[] }>(`/jobs${params?.status ? `?status=${params.status}` : ""}`),
  get: (id: string) => api<{ data: Job }>(`/jobs/${id}`),
  create: (body: JobInput) =>
    api<{ ok: boolean; data: Job }>(`/jobs`, { method: "POST", body }),
  update: (id: string, body: JobInput) =>
    api<{ ok: boolean }>(`/jobs/${id}`, { method: "PUT", body }),
  publish: (id: string) =>
    api<{ ok: boolean }>(`/jobs/${id}/publish`, { method: "POST" }),
  close: (id: string) =>
    api<{ ok: boolean }>(`/jobs/${id}/close`, { method: "POST" }),
  remove: (id: string) =>
    api<{ ok: boolean }>(`/jobs/${id}`, { method: "DELETE" }),
  draft: (body: {
    title: string
    department?: string | null
    location?: string | null
    employment_type?: string
    seniority?: string | null
    extra_context?: string | null
  }) =>
    api<{ description: string; requirements: string; model: string }>(`/jobs/draft`, {
      method: "POST",
      body,
    }),
}
